/* eslint-disable @typescript-eslint/naming-convention */
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { dataUrlMethod } from 'app/components/datagrid/datagrid.interface';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import { tap } from 'rxjs/operators';
import { NgEventBus } from 'ng-event-bus';

interface ButtonState {
    syncUid: string;
    retryLoading: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class InvoicesService {
    get paymentProviderUrl(): string{
        return `${this.dataCollectorService.baseurl()}/payments/provider`;
    }
    get invoiceAPIUrls(): any{
        return {
            dataUrl: `${this.dataCollectorService.baseurl()}/invoice/filter`,
            columnUrl: `${this.dataCollectorService.baseurl()}/invoice/meta`,
            filterUrl: `${this.dataCollectorService.baseurl()}/invoice/meta/filter`,
            invoiceUrl: `${this.dataCollectorService.baseurl()}/invoice`,
            noteAttachmentUrl: `${this.dataCollectorService.baseurl()}/note_attachment`,
            paymentUrl: `${this.dataCollectorService.baseurl()}/customer_portal/invoices/pay`,
            bulkActionUrl: `${this.dataCollectorService.baseurl()}/invoice/bulk_action`,
            templateUrl:`${this.dataCollectorService.baseurl()}/invoice_estimate/template`,
            paymentTermUrl: `${this.dataCollectorService.baseurl()}/invoices/payment_terms`,
            exportUrl: `${this.dataCollectorService.baseurl()}/invoice/account_receivable/export`,
            invoiceEstimateTemplate: `${this.dataCollectorService.baseurl()}/invoice_estimate/template`,
            invoiceStatementUrl: `${this.dataCollectorService.baseurl()}/invoice/statement`,
            dataUrlMethod: dataUrlMethod.POST
        };
    }
    invoiceDetailsLoaded: Subject<boolean> = new Subject<boolean>();
    refreshInvoiceDetails: Subject<any> = new Subject();
    currentInvoiceDetails = new BehaviorSubject<any>(null);
    syncHistoryStatusUpdated: Subject<ButtonState> = new Subject<ButtonState>();
    syncHistoryStatus: Observable<ButtonState> = this.syncHistoryStatusUpdated.asObservable();

    constructor(private dataCollectorService: DataCollectorService, private _eventBus: NgEventBus) {
        this.invoiceDetailsLoaded.next(false);
    }
    getInvoiceUrl(invoiceId: string): string {
        return `${this.dataCollectorService.baseurl()}/invoice/${invoiceId}`;
    }
    deleteURL(invoiceId: string): string {
        return `${this.dataCollectorService.baseurl()}/invoice/${invoiceId}`;
    }
    getSummaryUrl(): string{
        return `${this.dataCollectorService.baseurl()}/analytics/invoice`;
    }
    deleteInvoice(invoiceUid): Observable<any>{
        const invoiceUrl = `${this.dataCollectorService.baseurl()}/invoice/${invoiceUid}`;
        return this.dataCollectorService.deleteData(invoiceUrl).pipe(tap(()=>{
            this.castInvoiceEvent('delete',  {
                invoice_uid: invoiceUid
            });
        }));
    }
    updateInvoiceStatus(invoice): Observable<any>{
        const invoiceUrl = `${this.dataCollectorService.baseurl()}/invoice/${invoice.invoice_uid}/status`;
        const payload  = {
            invoice_status: invoice.invoice_status,
            invoice_uid: invoice.invoice_uid,
            payment_mode_uid: invoice.payment_mode_uid,
            amount_paid: invoice.amount_paid,
            remarks: invoice.remarks || '',
            reference_no:invoice.reference_no,
            payment_date : invoice.payment_date,
            source       : invoice.source,
            payment_transaction_uid : invoice.payment_transaction_uid,
            send_receipt: invoice.send_receipt,
            currency: invoice?.currency,
            charge_card: invoice?.charge_card,
            card_id: invoice?.card_id,
            receipt_email: invoice?.receipt_email

            
        };
        if(invoice?.payment_via === 'CREDIT'){
            payload["payment_via"] = "CREDIT"
            payload["credits"] = invoice?.credits;
        }
        return this.dataCollectorService.putData(invoiceUrl,payload).pipe(tap(()=>{
            this.castInvoiceEvent('status_update',  {
                invoice_uid: invoice.invoice_uid,
                invoice_status: invoice.invoice_status,
            });
        }));
    }
    cloneInvoice(invoiceUid): void{
    }
    PrintAndDownloadPDF(invoiceUid): Observable<HttpResponse<Blob>> {
        const invoiceUrl = `${this.dataCollectorService.baseurl()}/invoice/${invoiceUid}/send`;
        return this.dataCollectorService.postData(invoiceUrl,{},{ responseType: 'blob', observe: 'response' });
    }
    sendInvoice(invoiceUid,sendData): Observable<any>{
        const invoiceUrl = `${this.dataCollectorService.baseurl()}/invoice/${invoiceUid}/send`;
        return this.dataCollectorService.postData(invoiceUrl,sendData);
    }
    getPaymentModes(): Observable<any> {
        const invoiceUrl = `${this.dataCollectorService.baseurl()}/invoices/payment_modes`;
        return this.dataCollectorService.getData(invoiceUrl);
    }
    getOverdueInvoices(payload): Observable<any> {
        const invoiceUrl = this.invoiceAPIUrls.dataUrl;
        return this.dataCollectorService.postData(invoiceUrl, payload);
    }
    getInvoiceStats(): Observable<any> {
        const invoiceUrl = `${this.dataCollectorService.baseUrl}/analytics/ar_aging`;
        return this.dataCollectorService.getData(invoiceUrl);
    }

    financeInvoice(invoiceData): Observable<any>{
        const url = this.dataCollectorService.baseurl() + '/financing/'+ invoiceData.invoice_uid + '/payments';
        const payload = invoiceData.loanData;
        return this.dataCollectorService.postData(url,payload);
    }

    updateInvoiceDetails(invoiceUid, payload): Observable<any>{
      const url = this.dataCollectorService.baseurl()+'/invoice/' + invoiceUid;
      return this.dataCollectorService.putData(url, payload).pipe(tap(()=>{
        this.castInvoiceEvent('update', {
            invoice_uid: invoiceUid
        });
      }));
    }

    castInvoiceEvent(event, data): void{
        this._eventBus.cast('sdk:invoice:'+event,  data);
    }
    performBulkAction(payload): Observable<any>{
      const url = this.invoiceAPIUrls.bulkActionUrl;
      return this.dataCollectorService.postData(url,payload);
    }

    projectsDetailsUrl(projectsUid: string): string{
        return `${this.dataCollectorService.baseurl()}/projects/` + `${projectsUid}`;
    }
}
